module.exports = __webpack_public_path__ + "img/shoe3.e1da3e4b.svg";